module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Linda Lael Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The daughter of a town marshal, Linda Lael Miller is a #1 "), _c('I', [_vm._v("New York Times")]), _vm._v(" and "), _c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author of more than one hundred historical and contemporary novels, most of which reflect her love of the West. Raised in Northport, Washington, Linda pursued her wanderlust, living in London and Arizona and traveling the world before returning to the state of her birth to settle down on a horse property outside Spokane. Published since 1983, Linda was awarded the prestigious Nora Roberts Lifetime Achievement Award in 2007 by the Romance Writers of America. She was recently inducted into the Wild West Heritage Foundation's Walk of Fame for her dedication to preserving the heritage of the Wild West. When not writing, Linda loves to focus her creativity on a wide variety of art projects. Visit her online at LindaLaelMiller.com and Facebook.com/OfficialLindaLaelMiller.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FnwHzP/tc-custom/9781439106952.jpg?1730491660421",
      "alt": "This image is the cover for the book Springwater Seasons"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Springwater Seasons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('b', [_vm._v("Linda Lael Miller's national bestselling novels of frontier life overflow with the passion and warmth of Springwater, a tiny stagecoach stop that blossoms into a bustling Montana town.")]), _c('br', {
    attrs: {
      "background-color:": "",
      "font-size:": "",
      "open": "",
      "rgb": "",
      "sans": "",
      "sans-serif": ""
    }
  })]), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Rachel")])]), _c('br'), _vm._v(" Springwater's first schoolteacher, she crosses paths with rough-hewn barkeep Trey Hargreaves, who puts a slow burn on her proper Eastern ways."), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Savannah")])]), _c('br'), _vm._v(" Behind her rouge and bangles, the dance-hall girl has a sure and steady heart. Can her kind, gentle love help Dr. Prescott Parrish heal his wounded spirit?"), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Miranda")])]), _c('br'), _vm._v(" An unwed mother in search of a place to call home, she finds her heart's desire in Springwater—and in the arms of rancher Landry Kildare."), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Jessica")])]), _c('br'), _vm._v(" The sparks fly when she comes to take charge of her late brother's bankrupt newspaper—and finds herself in a heated love match with town mayor Gage Calloway."), _c('br'), _c('br'), _c('b', [_vm._v("FOUR SPLENDID SPRINGWATER NOVELS—TOGETHER FOR THE FIRST TIME!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gallery\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0